// @flow strict
import React from 'react';
import styledImport from 'styled-components';
const styled = styledImport.default || styledImport;
import type { Attribution } from '../../records/Photo.js';

type Props = {
  attribution: ?Attribution,
};

const OnClickLink = styled.a`
  cursor: pointer;
  color: inherit;
  text-decoration: none;
`;

const PhotoAttribution = ({ attribution }: Props) => {
  if (!attribution) {
    return null;
  }
  return (
    <span>
      {attribution &&
        (attribution.source || attribution.authorName || attribution.license) &&
        ' | '}
      {attribution.source && `${attribution.source}: `}
      {attribution.authorName &&
        (attribution.originalUrl ? (
          <OnClickLink
            href={attribution.originalUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {attribution.authorName}{' '}
          </OnClickLink>
        ) : (
          `${attribution.authorName} `
        ))}
      {attribution.license &&
        (attribution.licenseUrl ? (
          <OnClickLink
            href={attribution.licenseUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {attribution.license}
          </OnClickLink>
        ) : (
          `${attribution.license}`
        ))}
    </span>
  );
};

export default PhotoAttribution;
